import AgencyIndex from ".";

export const agencyRoutes = {
    path: "agency",
    children: [
        { index: true, element: <AgencyIndex /> }
    ]
}